(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      
      // Initial icon color update
      setTimeout(() => this.updateIconColors(), 100);
    }

    setHeaderHeight() {
      if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
      
      // Update icon colors on scroll
      this.updateIconColors();
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.updateIconColors();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.updateIconColors();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.updateIconColors();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    updateIconColors() {
      // Get header wrapper
      const headerWrapper = document.querySelector('.header-wrapper');
      if (!headerWrapper) return;
      
      // Check states
      const isTransparent = headerWrapper.classList.contains('transparent-active');
      const isScrolled = this.header && this.header.classList.contains('scrolled-past-header');
      
      // Should be white only if transparent AND not scrolled
      const shouldBeWhite = isTransparent && !isScrolled;
      
      // Find all SVG icons
      const allSvgs = document.querySelectorAll('.header__icon svg, header-drawer svg, .svg-wrapper svg');
      
      allSvgs.forEach(svg => {
        if (shouldBeWhite) {
          // White
          svg.style.filter = 'brightness(0) invert(1)';
          svg.style.stroke = '#FFFFFF';
          svg.setAttribute('stroke', '#FFFFFF');
        } else {
          // Dark
          svg.style.filter = 'none';
          svg.style.stroke = '#2D2B2A';
          svg.setAttribute('stroke', '#2D2B2A');
        }
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Force update on page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.updateIconColors();
      }
    }, 300);
  });

  // Update on cart changes
  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.updateIconColors();
      }
    }, 200);
  });

  } catch(e) { console.error(e); }
})();
})();
